import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';


const firebaseConfig = {
  apiKey: "AIzaSyAJubZ-Mh4Oshs8THIYJexQ47vl2QUWbn8",
  authDomain: "vedit-beladia.firebaseapp.com",
  databaseURL: "https://vedit-beladia-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "vedit-beladia",
  storageBucket: "vedit-beladia.appspot.com",
  messagingSenderId: "545606232709",
  appId: "1:545606232709:web:c42d86592f44ebac6557ec",
  measurementId: "G-RL3742GCXP"
};

firebase.initializeApp(firebaseConfig);
const database = firebase.database();

export const storage = firebase.storage();

export default database;
